import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '/#services'
  }, {
    name: 'Our People',
    href: '/#our-people'
  }, {
    name: 'Contact',
    href: '/#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/90 backdrop-blur-md py-4 border-b border-white/5' : 'bg-transparent py-6'}`} data-id="element-102">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-103">
        <Link to="/" className="flex items-center" data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/xtgWxKgk7LvgDaYASSWAq2/Cognisensus_logo_traced_(1).svg" alt="Cognisensus" className="h-9 md:h-11" style={{
          filter: 'brightness(0) invert(1)'
        }} data-id="element-105" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-106">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-offwhite-muted hover:text-amber transition-colors" data-id="element-107">
              {link.name}
            </a>)}
          <a href="/#contact" className="px-5 py-2.5 bg-amber text-navy font-medium text-sm rounded-sm hover:bg-amber-hover transition-colors" data-id="element-108">
            Schedule a Consultation
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-offwhite" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-109">
          {mobileMenuOpen ? <X size={24} data-id="element-110" /> : <Menu size={24} data-id="element-111" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-112">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-navy-light border-b border-white/5 shadow-xl md:hidden" data-id="element-113">
            <div className="flex flex-col px-6 py-4 gap-4" data-id="element-114">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-offwhite-muted hover:text-amber transition-colors py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-115">
                  {link.name}
                </a>)}
              <a href="/#contact" onClick={() => setMobileMenuOpen(false)} className="w-full mt-4 px-5 py-3 bg-amber text-navy font-medium text-sm rounded-sm hover:bg-amber-hover transition-colors text-center" data-id="element-116">
                Schedule a Consultation
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}